'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _capitalize = require('lodash/capitalize');

var _capitalize2 = _interopRequireDefault(_capitalize);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _withForm = require('constructicon/with-form');

var _withForm2 = _interopRequireDefault(_withForm);

var _validators = require('constructicon/lib/validators');

var validators = _interopRequireWildcard(_validators);

var _authentication = require('../../api/authentication');

var _client = require('../../utils/client');

var _form = require('../../utils/form');

var _form2 = require('constructicon/form');

var _form3 = _interopRequireDefault(_form2);

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _gridColumn = require('constructicon/grid-column');

var _gridColumn2 = _interopRequireDefault(_gridColumn);

var _heading = require('constructicon/heading');

var _heading2 = _interopRequireDefault(_heading);

var _inputField = require('constructicon/input-field');

var _inputField2 = _interopRequireDefault(_inputField);

var _inputSelect = require('constructicon/input-select');

var _inputSelect2 = _interopRequireDefault(_inputSelect);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SignupForm = function (_Component) {
  _inherits(SignupForm, _Component);

  function SignupForm() {
    _classCallCheck(this, SignupForm);

    var _this = _possibleConstructorReturn(this, (SignupForm.__proto__ || Object.getPrototypeOf(SignupForm)).call(this));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.state = {
      status: 'empty',
      errors: []
    };
    return _this;
  }

  _createClass(SignupForm, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var _props = this.props,
          clientId = _props.clientId,
          _props$country = _props.country,
          country = _props$country === undefined ? 'au' : _props$country,
          form = _props.form,
          includeAddress = _props.includeAddress,
          onSuccess = _props.onSuccess,
          resetPasswordUrl = _props.resetPasswordUrl;


      var platform = (0, _client.isJustGiving)() ? 'JustGiving' : 'everydayhero';
      var jgSubdomain = (0, _client.isStaging)() ? 'www.staging' : 'www';
      var edhDomain = (0, _client.isStaging)() ? 'everydayhero-staging' : 'everydayhero';
      var defaultResetPasswordUrl = (0, _client.isJustGiving)() ? 'https://' + jgSubdomain + '.justgiving.com/sso/resetpassword?ReturnUrl=https%3A%2F%2F' + jgSubdomain + '.justgiving.com%2F&Context=consumer&ActionType=set_profile' : 'https://' + edhDomain + '.com/' + country + '/passwords/new';

      return form.submit().then(function (data) {
        _this2.setState({
          errors: [],
          status: 'fetching'
        });

        var dataPayload = (0, _client.isJustGiving)() ? (0, _merge2.default)(_extends({
          title: data.title || 'Other'
        }, data), includeAddress && {
          address: {
            line1: data.line1,
            line2: data.line2,
            townOrCity: data.townOrCity,
            countyOrState: data.countyOrState,
            country: data.country,
            postcodeOrZipcode: data.postcodeOrZipcode
          }
        }) : _extends({
          clientId: clientId,
          country: country,
          name: [data.firstName, data.lastName].join(' ')
        }, data);

        return (0, _authentication.signUp)(dataPayload).then(function (result) {
          _this2.setState({ status: 'fetched' });

          return onSuccess(result);
        }).catch(function (error) {
          switch (error.status) {
            case 422:
              var errors = (0, _get2.default)(error, 'data.error.errors') || [];

              return _this2.setState({
                status: 'failed',
                errors: errors.map(function (_ref, key) {
                  var field = _ref.field,
                      message = _ref.message;

                  if (field === 'email' && message === 'has already been taken') {
                    return {
                      message: _react2.default.createElement(
                        'div',
                        { key: key },
                        _react2.default.createElement(
                          'p',
                          null,
                          'Your password is incorrect.'
                        ),
                        _react2.default.createElement(
                          'p',
                          null,
                          'Please try again, or you can',
                          ' ',
                          _react2.default.createElement(
                            'a',
                            {
                              href: resetPasswordUrl || defaultResetPasswordUrl,
                              target: '_blank'
                            },
                            'reset your ',
                            platform,
                            ' password here.'
                          )
                        )
                      )
                    };
                  }

                  return { message: [(0, _capitalize2.default)(field), message].join(' ') };
                })
              });
            default:
              var message = (0, _get2.default)(error, 'data.error.message') || (0, _get2.default)(error, 'data.errorMessage');

              return _this2.setState({
                status: 'failed',
                errors: message ? [{ message: message }] : []
              });
          }
        });
      });
    }
  }, {
    key: 'customFields',
    value: function customFields(fields) {
      return (0, _form.renderFormFields)(fields, ['firstName', 'lastName', 'email', 'password', 'phone', 'line1', 'line2', 'townOrCity', 'countyOrState', 'country', 'postcodeOrZipcode']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          country = _props2.country,
          disableInvalidForm = _props2.disableInvalidForm,
          form = _props2.form,
          formComponent = _props2.formComponent,
          grid = _props2.grid,
          gridColumn = _props2.gridColumn,
          includeAddress = _props2.includeAddress,
          inputField = _props2.inputField,
          legend = _props2.legend,
          submit = _props2.submit;
      var _state = this.state,
          status = _state.status,
          errors = _state.errors;


      return _react2.default.createElement(
        _form3.default,
        _extends({
          errors: errors,
          isDisabled: disableInvalidForm && form.invalid,
          isLoading: status === 'fetching',
          noValidate: true,
          onSubmit: this.handleSubmit,
          submit: submit,
          autoComplete: 'off'
        }, formComponent),
        _react2.default.createElement(
          _grid2.default,
          _extends({ spacing: { x: 0.5 } }, grid),
          _react2.default.createElement(
            _gridColumn2.default,
            _extends({ sm: 6 }, gridColumn),
            _react2.default.createElement(_inputField2.default, _extends({}, form.fields.firstName, inputField))
          ),
          _react2.default.createElement(
            _gridColumn2.default,
            _extends({ sm: 6 }, gridColumn),
            _react2.default.createElement(_inputField2.default, _extends({}, form.fields.lastName, inputField))
          )
        ),
        _react2.default.createElement(_inputField2.default, _extends({}, form.fields.email, inputField)),
        _react2.default.createElement(_inputField2.default, _extends({}, form.fields.password, inputField)),
        !(0, _client.isJustGiving)() ? country ? _react2.default.createElement(_inputField2.default, _extends({}, form.fields.phone, inputField)) : _react2.default.createElement(
          _grid2.default,
          _extends({ spacing: { x: 0.5 } }, grid),
          _react2.default.createElement(
            _gridColumn2.default,
            _extends({ sm: 7 }, gridColumn),
            _react2.default.createElement(_inputField2.default, _extends({}, form.fields.phone, inputField))
          ),
          _react2.default.createElement(
            _gridColumn2.default,
            _extends({ sm: 5 }, gridColumn),
            _react2.default.createElement(_inputSelect2.default, _extends({}, form.fields.country, inputField))
          )
        ) : includeAddress && _react2.default.createElement(
          'fieldset',
          null,
          _react2.default.createElement(
            _heading2.default,
            _extends({ tag: 'legend' }, legend),
            'Address'
          ),
          _react2.default.createElement(_inputField2.default, _extends({}, form.fields.line1, inputField)),
          _react2.default.createElement(_inputField2.default, _extends({}, form.fields.line2, inputField)),
          _react2.default.createElement(
            _grid2.default,
            _extends({ spacing: { x: 0.5 } }, grid),
            _react2.default.createElement(
              _gridColumn2.default,
              _extends({ sm: 7 }, gridColumn),
              _react2.default.createElement(_inputField2.default, _extends({}, form.fields.townOrCity, inputField))
            ),
            _react2.default.createElement(
              _gridColumn2.default,
              _extends({ sm: 5 }, gridColumn),
              _react2.default.createElement(_inputField2.default, _extends({}, form.fields.countyOrState, inputField))
            )
          ),
          _react2.default.createElement(
            _grid2.default,
            _extends({ spacing: { x: 0.5 } }, grid),
            _react2.default.createElement(
              _gridColumn2.default,
              _extends({ sm: 8 }, gridColumn),
              _react2.default.createElement(_inputSelect2.default, _extends({}, form.fields.country, inputField))
            ),
            _react2.default.createElement(
              _gridColumn2.default,
              _extends({ sm: 4 }, gridColumn),
              _react2.default.createElement(_inputField2.default, _extends({}, form.fields.postcodeOrZipcode, inputField))
            )
          )
        ),
        this.customFields(form.fields).map(function (field) {
          var Tag = (0, _form.renderInput)(field.type);
          return _react2.default.createElement(Tag, _extends({ key: field.name }, field, inputField));
        })
      );
    }
  }]);

  return SignupForm;
}(_react.Component);

SignupForm.propTypes = {
  /**
   * The clientId for a valid OauthApplication (EDH only)
   */
  clientId: _propTypes2.default.string,

  /**
   * Country for new user (EDH only)
   */
  country: _propTypes2.default.oneOf(['au', 'nz', 'uk', 'us', 'ie']),

  /**
   * Disable form submission when invalid
   */
  disableInvalidForm: _propTypes2.default.bool,

  /**
   * Fields to be passed to the form HOC
   */
  fields: _propTypes2.default.object,

  /**
   * Props to be passed to the Form component
   */
  formComponent: _propTypes2.default.object,

  /**
   * Props to be passed to the Grid components
   */
  grid: _propTypes2.default.object,

  /**
   * Props to be passed to the GridColumn components
   */
  gridColumn: _propTypes2.default.object,

  /**
   * Include address form (JG only)
   */
  includeAddress: _propTypes2.default.bool,

  /**
   * Props to be passed to the InputField components
   */
  inputField: _propTypes2.default.object,

  /**
   * Props to be passed to the Heading component used as a form legend
   */
  legend: _propTypes2.default.object,

  /**
   * The onSuccess event handler
   */
  onSuccess: _propTypes2.default.func.isRequired,

  /**
   * Reset password URL to display on error
   */
  resetPasswordUrl: _propTypes2.default.string,

  /**
   * The label for the form submit button
   */
  submit: _propTypes2.default.string
};

SignupForm.defaultProps = {
  disableInvalidForm: false,
  fields: {},
  submit: 'Sign Up',
  legend: {
    size: 0.5,
    color: 'primary'
  }
};

var form = function form(props) {
  var includeCountry = !(0, _client.isJustGiving)() && !props.country;
  var includeAddress = (0, _client.isJustGiving)() && props.includeAddress;

  var fields = (0, _merge2.default)({
    firstName: {
      label: 'First name',
      type: 'text',
      required: true,
      maxLength: 30,
      validators: [validators.required('Please enter a first name'), validators.alphaNumericSpecial('Please enter a valid first name')]
    },
    lastName: {
      label: 'Last name',
      type: 'text',
      required: true,
      maxLength: 50,
      validators: [validators.required('Please enter a last name'), validators.alphaNumericSpecial('Please enter a valid last name')]
    },
    email: {
      label: 'Email address',
      type: 'email',
      required: true,
      autoComplete: 'off',
      validators: [validators.required('Email is a required field'), validators.email('Must be a valid email')]
    },
    password: {
      label: 'Password',
      type: 'password',
      required: true,
      autoComplete: 'off',
      validators: [validators.required('Password is a required field'), validators.greaterThan(7, 'Must be at least 8 characters')]
    }
  }, !(0, _client.isJustGiving)() && {
    phone: {
      label: 'Phone Number',
      type: 'tel',
      required: true,
      validators: [validators.required('Please enter your phone number')]
    }
  }, includeCountry && {
    country: {
      label: 'Country',
      type: 'select',
      required: true,
      validators: [validators.required('Please select a country')],
      options: [{
        label: 'Select a country',
        value: '',
        disabled: true
      }, {
        label: 'Australia',
        value: 'au'
      }, {
        label: 'New Zealand',
        value: 'nz'
      }, {
        label: 'United States',
        value: 'us'
      }, {
        label: 'United Kingdom',
        value: 'uk'
      }, {
        label: 'Ireland',
        value: 'ie'
      }]
    }
  }, includeAddress && {
    line1: {
      label: 'Street address',
      type: 'text',
      required: true,
      validators: [validators.required('Please enter your street address')]
    },
    line2: {
      label: 'Unit / Townhouse / Level',
      type: 'text'
    },
    townOrCity: {
      label: 'Town / City',
      type: 'text',
      required: true,
      validators: [validators.required('Please enter your town, city or locality')]
    },
    countyOrState: {
      label: 'County / State',
      type: 'text'
    },
    country: {
      label: 'Country',
      type: 'select',
      required: true,
      validators: [validators.required('Please select a country')],
      options: [{
        label: 'Select a country',
        value: '',
        disabled: true
      }, {
        label: 'United Kingdom',
        value: 'GB'
      }, {
        label: 'Ireland',
        value: 'IE'
      }, {
        label: 'Hong Kong',
        value: 'HK'
      }, {
        label: 'Australia',
        value: 'AU'
      }, {
        label: 'United States',
        value: 'US'
      }]
    },
    postcodeOrZipcode: {
      label: 'Postcode',
      type: 'text',
      maxLength: 8,
      required: true,
      validators: [validators.required('Please enter your postcode / zip')]
    }
  }, props.fields);

  return { fields: fields };
};

exports.default = (0, _withForm2.default)(form)(SignupForm);


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/signup-form/index.js
// module id = 1337
// module chunks = 0